import { AppFooter } from "./app-footer";
import { Outlet } from "react-router";
import { AuthAnimatedBackground } from "./auth-animated-background";
import { AuthHeader } from "./auth-header";

export function AuthLayout() {
  return (
    <div className="relative isolate flex min-h-screen flex-col overflow-hidden">
      <AuthAnimatedBackground />
      <AuthHeader />
      <div className="relative z-10 flex-1">
        <Outlet />
      </div>
      <div className="relative z-10">
        <AppFooter />
      </div>
    </div>
  );
}
